import BasicDetails from './BasicDetails';
import Deductions from './Deductions';
import IncomeDetails from './IncomeDetails';
import { GraphCalculation } from './graphs-calculation';
import { tabsData } from './types';

export const BasicDetailsdata = [
  {
    id: 'Year',
    label: 'Financial year',
    value: '2025-2026',
    showLabel: true,
    optionsArray: [
      {
        id: 'id2',
        label:
          'FY 2026-2027 (Return to be filed between 1st April 2027 - 31st December 2027) - Latest',
        value: '2026',
      },
      {
        id: 'id1',
        label:
          'FY 2025-2026 (Return to be filed between 1st April 2026 - 31st December 2026)',
        value: '2025',
      },
    ],
    onChange: () => {},
    placeholder: '2024-2025',
  },
  {
    id: 'AgeGroup',
    label: 'Age group',
    value: '0-60',
    showLabel: true,
    optionsArray: [
      {
        id: 'id1',
        label: '0-60',
        value: 'NotSenior',
      },
      {
        id: 'id2',
        label: '60-80',
        value: 'Senior',
      },
      {
        id: 'id3',
        label: '80 & above',
        value: 'SuperSenior',
      },
    ],
    onChange: () => {},
    placeholder: '0-60',
  },
];

export const leftIncomeDetails = [
  {
    label: 'Income from Salary',
    showLabel: true,
    id: 'TaxableSalary',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },

    info: {
      enabled: true,
      text: 'Salary before reducing HRA, LTA, standard deductions & professional tax. If applicable, reduce leave encashment (max: 25L)',
    },
  },
  {
    label: 'Income from interest',
    showLabel: true,
    id: 'InterestIncome',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Includes interest from savings bank, deposits and other interest',
    },
  },
  {
    label: 'Rental income received',
    showLabel: true,
    id: 'RentalPropertyIncome',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Annual rent received on let-out property (Standard deduction @30% will be auto calculated)',
    },
  },
  {
    label: 'Income from digital assets',
    showLabel: true,
    id: 'DigitalAssetIncome',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Net Income from Digital Assets, taxed at 30%',
    },
  },
];
export const rightIncomeDetails = [
  {
    label: 'Exempt allowances',
    showLabel: true,
    id: 'ExemptIncome',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'HRA, LTA, Professional Tax and any Other Exemptions',
    },
  },
  {
    label: 'Interest on home loan - Self occupied',
    showLabel: true,
    id: 'OccupiedPropertyInterest',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Interest paid on housing loan taken for self-occupied property',
    },
  },
  {
    label: 'Interest on Home Loan- Let Out',
    showLabel: true,
    id: 'RentalPropertyInterest',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Interest paid on housing loan taken for rented/let-out property',
    },
  },
  {
    label: 'Other income',
    showLabel: true,
    id: 'OtherIncome',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Includes taxable freelancing income or any other taxable income',
    },
  },
];
export const leftDeductionDetails = [
  {
    label: 'Basic deductions - 80C',
    showLabel: true,
    id: 'Section80C',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Amount invested/paid in tax saving instruments such as PPF, ELSS mutual funds, LIC premium, etc. (max: 1.5L)',
    },
  },
  {
    label: 'Medical insurance - 80D',
    showLabel: true,
    id: 'Section80D',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Medical premium & preventive health checkup fees paid for self & family including parents',
    },
  },
  {
    label: 'Interest on housing loan - 80EEA',
    showLabel: true,
    id: 'Section80EEA',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Amount of interest paid on housing loan sanctioned during FY 2022-2023 (max: 1.5L)',
    },
  },

  {
    label: 'Employer’s contribution to NPS - 80CCD(2)',
    showLabel: true,
    id: 'Section80CCD2',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Amount of contributions made by employer to the National Pension Scheme (NPS) under Section 80CCD(2)',
    },
  },
];
export const rightDeductionDetails = [
  {
    label: 'Interest from deposits - 80TTA',
    showLabel: true,
    id: 'Section80TTA',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Amount of interest income on deposits in savings account (includes fixed/recurring deposit interest in case of senior citizen)',
    },
  },
  {
    label: 'Donations to charity - 80G',
    showLabel: true,
    id: 'Section80G',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Amount paid as donation to charitable insitutions or certain recognized funds',
    },
  },

  {
    label: 'Employee’s contribution to NPS - 80CCD',
    showLabel: true,
    id: 'Section80CCD',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Includes voluntary contribution to National Pension Scheme (NPS) under section 80CCD(1) and 80CCD(1B)',
    },
  },
  {
    label: 'Any other deduction',
    showLabel: true,
    id: 'Section80E',
    onTextChangeFn: () => {},
    onBlurFn: () => {},
    placeholder: 'Value',
    type: 'text',
    prefix: {
      enabled: true,
      icon: '₹',
    },
    info: {
      enabled: true,
      text: 'Enter the deduction amount to be claimed under any other sections not listed above',
    },
  },
];
export const tabsDataIncomeTax: tabsData = {
  tabStyles: {
    activeStyle:
      'px-6 py-2 sm:p-[10px]  sm:text-s-14 cursor-pointer  font-medium border-b-md border-blue-350 text-blue-350 whitespace-nowrap',
    inActiveStyle:
      'px-6 py-2 sm:p-[10px]  sm:text-s-14 cursor-pointer  font-medium text-blue-200  whitespace-nowrap',
    isButton: true,
  },
  tabs: [
    { index: 0, label: 'Basic details', component: BasicDetails },
    { index: 1, label: 'Income details', component: IncomeDetails },
    { index: 2, label: 'Deduction', component: Deductions },
  ],
};

export const taxRegimeTab: tabsData = {
  tabStyles: {
    activeStyle:
      'px-4 py-2 sm:p-0 sm:pb-2.5 md:p-0 md:pb-2 sm:text-s-14 sm:font-medium md:text-s-12 flex items-center gap-2 cursor-pointer font-medium border-b-md border-blue-350 text-font-500 font-medium',
    inActiveStyle:
      'px-4 py-2 sm:p-0 sm:pb-2.5 md:p-0 md:pb-2 sm:text-s-14 sm:font-medium md:text-s-12 flex items-center gap-2 cursor-pointer font-medium text-font-200 border-b-md border-b-white',
    isButton: false,
  },
  tabs: [
    { index: 0, label: 'New regime', component: GraphCalculation },
    { index: 1, label: 'Old regime', component: GraphCalculation },
  ],
};
